import { IKCExpressionRuntime, KCExpressionRuntime, PlainModelValue } from "../KCExpressionRuntime";
import { IEvaluationContext } from "../IEvaluationContext";
import { isNotNullOrUndefined } from "../../../../../../Common/TypingUtils";

type AutoCalcEvaluatorFunc = (kcExpression: IKCExpressionRuntime) => PlainModelValue | boolean;

export class KCCalculation {
    public static execute(
        context: IEvaluationContext,
        evaluator: AutoCalcEvaluatorFunc,
        defaultValue: string
    ): PlainModelValue {
        const expression = new KCExpressionRuntime(context);
        const result = evaluator(expression);
        const finalValue = isNotNullOrUndefined(result)
            ? result
            : isNotNullOrUndefined(defaultValue)
              ? defaultValue
              : undefined;
        return finalValue?.toString();
    }
}
